import { useState, useEffect } from "react";

const getLastQueryDate = () => {
  return localStorage.getItem("lastQueryDate");
};

const setLastQueryDate = (date) => {
  localStorage.setItem("lastQueryDate", date);
};

export const useFirstQueryOfTheDay = (agreed) => {
  const [isFirstQuery, setIsFirstQuery] = useState(false);

  useEffect(() => {
    const today = new Date().toDateString();
    const lastQueryDate = getLastQueryDate();

    if (lastQueryDate !== today) {
      setIsFirstQuery(true);
    }
  }, []);

  useEffect(() => {
    const today = new Date().toDateString();
    if (agreed) setLastQueryDate(today);
  }, [agreed]);

  return isFirstQuery;
};
